import UserSession from "../domain/User/UserSession";
import BasicAuthGenerator from "../utils/BasicAuthGenerator";
import CustomerService from "./Customer/CustomerService";
import CookieService, {CookieKey} from "./CookieService";

const TRANSACTING_PARTNER_ID = process.env.REACT_APP_TRANSACTING_PARTNER_ID;
const TRANSACTING_CHANNEL_ID = process.env.REACT_APP_TRANSACTING_CHANNEL_ID;

const REGISTERING_PARTNER_ID = process.env.REACT_APP_REGISTERING_PARTNER_ID;
const REGISTERING_CHANNEL_ID = process.env.REACT_APP_REGISTERING_CHANNEL_ID;

const REGISTERING_PARTNER_USERNAME = process.env.REACT_APP_REGISTERING_PARTNER_USERNAME;
const REGISTERING_PARTNER_PASSWORD = process.env.REACT_APP_REGISTERING_PARTNER_PASSWORD;

const CARD_PAYMENT_PARTNER_ID = process.env.REACT_APP_CARD_PAYMENT_PARTNER_ID;

const UserSessionService = {
    login, logout,
    isAuthenticated,
    getCustomerProfile, getBasicAuth: getBasicAuthCredentials,
    isSessionValid,
    retrieveTransactingHeaders,
    retrieveRegisteringHeaders,
    retrieveRegisteringAuth,
    retrieveCardPaymentHeaders,
    storeConversationId,
    retrieveConversationId
};
export default UserSessionService;

const api_url = process.env.REACT_APP_API_URL;

function login(username, password) {
    let basicAuthCredentials = BasicAuthGenerator.create(username, password);
    return loginWithCredentials(basicAuthCredentials);

}

function loginWithCredentials(basicAuthCredentials) {

    let requestParams = {
        method: "GET",
        headers: new Headers({
            'Authorization': basicAuthCredentials,
            'Accept': 'application/json',
        }),
    };

    return fetch(api_url + "/authentication/app", requestParams)
        .then((response) => {
            if (response.status === 200)
                return response.json();
            if (response.status === 403)
                return response.statusText;
            else
                throw Error(response.statusText);
        })
        .then(function (response) {
            return handleResponse(response, basicAuthCredentials);
        })
        .catch(handleError);
}

function logout() {
    CookieService.removeCookie(CookieKey.BASIC_AUTH);
    CookieService.removeCookie(CookieKey.USER_PROFILE);
}

function handleResponse(response, basicAuthCredentials) {
    if(response === "Forbidden")
        return response;

    let userSession = new UserSession(response);

    return CustomerService.retrieveCustomerByUsername(userSession.username, basicAuthCredentials).then(customerResponse => {
        if (customerResponse.registrationId) {
            CookieService.setCookie(CookieKey.BASIC_AUTH, basicAuthCredentials);
            CookieService.setCookie(CookieKey.RETURNING_USER, userSession.username);
            CookieService.setCookie(CookieKey.USER_PROFILE, JSON.stringify(customerResponse));
            return true;
        } else {
            return false;
        }
    });
}

function handleError(error) {
    return false;
}

export function getBasicAuthCredentials() {
    extendSession();
    return CookieService.getCookie(CookieKey.BASIC_AUTH);
}


export function isSessionValid() {

    let profile = getCustomerProfile();
    if (!(isAuthenticated() && profile)) {
        window.location.reload(true);
        return false;
    }
    return true;
}

function extendSession() {
    CookieService.touchCookie(CookieKey.BASIC_AUTH);
    CookieService.touchCookie(CookieKey.USER_PROFILE);
}

export function isAuthenticated() {
    let auth = getBasicAuthCredentials();
    let profile = getCustomerProfile();
    return auth && profile && auth.length > 0 && profile.registrationId;
}

export function getCustomerProfile() {
    return CookieService.getCookie(CookieKey.USER_PROFILE);
}

export function retrieveTransactingHeaders() {
    return {
        "transacting-partner-id": TRANSACTING_PARTNER_ID,
        "channel-id": TRANSACTING_CHANNEL_ID
    }
}

export function retrieveCardPaymentHeaders() {
    return {
        "payment-partner-id": CARD_PAYMENT_PARTNER_ID
    }
}

export function retrieveRegisteringAuth() {
    return {
        "registering-partner-username": REGISTERING_PARTNER_USERNAME,
        "registering-partner-password": REGISTERING_PARTNER_PASSWORD
    }
}

export function retrieveRegisteringHeaders() {
    let headers = retrieveRegisteringAuth();
    headers["registering-partner-id"] = REGISTERING_PARTNER_ID;
    headers["registering-channel-id"] = REGISTERING_CHANNEL_ID;
    return headers;
}

export function storeConversationId(conversationId){
    CookieService.setCookie(CookieKey.CONVERSATION_ID, conversationId)
}

export function retrieveConversationId(){
    return CookieService.getCookie(CookieKey.CONVERSATION_ID)
}
